export const ProgressStepper = 'atlantis-progress-stepper';
export const ProgressStepperItem = 'atlantis-progress-step';